import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import httpRequestWrapper from "../../authentication/httpRequestWrapper";

const routePrefix = "/internal/";

const InternalApi = {
    saveFoto(fileName, content, tochtTypeId) {
        const serviceUrl = prependRoot(routePrefix + "/saveFoto", getApiRoot());
        return httpRequestWrapper.put(serviceUrl, { fileName: fileName, content: content, tochtTypeId: tochtTypeId });
    },

    publishTochtToUIV(tochtId) {
        const serviceUrl = prependRoot(routePrefix + "/publishtouiv/" + tochtId, getApiRoot());
        return httpRequestWrapper.put(serviceUrl, null);
    }
};

export default InternalApi;
